<i18n lang='yml' src='../i18n/SessionDetails.yml'></i18n>
<template>
  <div v-if='details' class="session-details">
    <div class="sittings-details-wrap">
      <div class="action-bar pl-2">
        <h6>{{$t('session_details')}}</h6>
        <div class="btn-group btn-group-xs ml-auto" role="group">
          <button class="btn btn-sm d-none d-md-block btn-outline-danger" @click="$emit('clear')">                                         
            {{$t('close')}}
          </button>
        </div>
      </div>
      <div class="exam-details">
        <ul>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-5 col-xl-6 exam-details-list">
               <li class="row">
                <span class="status-bold col-xs-12 col-md-6">
                  {{$t('scheduled_date')}}
                </span>
                <span class="col-xs-12 col-md-5">{{formatDate(details.date)}}</span> 
              </li>
              <li class="row">
                <span class="status-bold ol-xs-12 col-md-6">
                  {{$t('scheduled_time')}}
                </span>
                <span class="col-xs-12 col-md-5">{{formatTime(details.start_time)}} - {{formatTime(details.end_time)}}</span> 
              </li>
              <li class="row" v-if="booking_details && admin == 'true'">
                <span class="status-bold col-xs-12 col-md-6">
                  {{$t('exam_type')}}
                </span>
                <span class="col-xs-12 col-md-5">{{type == 'edit' ? booking_details.exam_type.name[locale] : booking_details.exam_type_name[locale]}}</span> 
              </li>
              <li class="row">
                <span class="status-bold col-xs-12 col-md-6">
                  {{$t('seats_available')}}
                </span>
                <span class="col-xs-12 col-md-5">{{details.number_of_seats}} {{$t('total_seats_available')}}</span> 
              </li>
              <li class="row">
                <span class="status-bold col-xs-12 col-md-6">
                  {{$t('seats_booked')}}
                </span>
                <span class="col-xs-12 col-md-5">{{details.booked_seats}} {{$t('seats_booked_list')}}</span> 
              </li>
    
              <li class="row" v-if="admin == 'true'">
                <span class="status-bold col-xs-12 col-md-6">
                  {{$t('local_only')}}
                </span>
                <span class="col-xs-12 col-md-5">{{details.local_only ? $t('yes_val') : $t('no_val')}}</span> 
              </li>
              <li class="row" v-if="admin == 'true'">
                <span class="status-bold col-xs-12 col-md-6">
                  {{$t('restricted_online')}}
                </span>
                <span class="col-5">{{details.allow_online_booking ? $t('yes_val') : $t('no_val')}}</span> 
              </li>
              <li class="row" v-if="admin == 'true'">
                <span class="status-bold col-xs-12 col-md-6">
                  {{$t('booth_available')}}
                </span>
                <span class="col-xs-12 col-md-5">{{details.exam_booth_available ? $t('yes_val') : $t('no_val')}}</span> 
              </li>
              <li class="row" v-if="admin == 'true'"> 
                <span class="status-bold col-xs-12 col-md-6">
                  {{$t('booth_capacity')}}
                </span>
                <span class="cool-xs-12 col-md-5">{{details.exam_booth_available ? details.booth_capacity : "N/A"}}</span> 
              </li>
               <li class="row" v-if="admin == 'true'"> 
                  <span class="status-bold col-xs-12 col-md-6">
                    {{$t('booth_booked')}}
                  </span>
                  <span class="col-xs-12 col-md-5">{{details.exam_booth_available ? details.booked_booth : "N/A"}}</span> 
                </li>
              
              <li class="row" v-if="admin == 'true'">
                <span class="status-bold col-xs-12 col-md-6">
                  {{$t('extra_time_available')}}
                </span>
                <span class="col-xs-12 col-md-5">{{details.extra_time_available ? $t('yes_val') : $t('no_val')}}</span>
              </li> 
              <li class="row" v-if="admin == 'true'">
                <span class="status-bold col-xs-12 col-md-6">
                  {{$t('status')}}
                </span>
                <span class="col-xs-12 col-md-5">{{$t(details.status)}}</span>
              </li>
                                   
            </div>
            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <li class="row">
                <span class="status-bold col-xs-12 col-md-6">
                  {{$t('location')}}
                </span>
                <span class="col-xs-12 col-md-5">{{details.sub_location.name[locale]}}</span> 
              </li>
              <li class="row">             
                <span class="status-bold col-xs-12 col-md-6">
                  {{$t('location_address')}}
                </span>
                <span class="col-xs-12 col-md-5">
                  {{details.sub_location.street_address}},
                  {{details.sub_location.city}},
                  {{details.sub_location.province}},
                  {{details.sub_location.postal_code}}
                </span> 
              </li>

              <li class="mt-md-4 row">
                <span class="status-bold col-xs-12 col-md-6">
                  {{$t('phone_number')}}
                </span>             
                <span class="col-xs-12 col-md-5">{{details.sub_location.phone_number}} {{details.sub_location.phone_number_extension}}</span> 
              </li>
              <li class="row">
                <span class="status-bold col-xs-12 col-md-6">
                  {{$t('email')}}
                </span>
                <span class="col-xs-12 col-md-5">
                  <a :href="`mailto:${details.sub_location.email}`">{{details.sub_location.email}}</a>
                  </span> 
              </li>
            
            </div>
          </div>
        </ul>
        <hr/>
        <div class="row">  
          <div class="col-xs-12 w-100 d-flex px-3 mb-2">
            <div v-if="context == 'booking' && !isInPast() && seatAvailable() && privateRoomAvailable()">  
              <template v-if="admin == 'true'">
                <button href="#" @click.prevent="addToCart" :disabled="isAlreadySelected()" class="btn btn-md btn-success">{{$t('add_to_cart')}}</button>
              </template>
              <template v-else>
                <button href="#" @click="nextStep" :aria-label="$t('book')" class="btn btn-md btn-success">{{$t('book')}}</button>
              </template> 
            </div>
            <button class="btn btn-sm d-md-none btn-light ml-auto" :aria-label="$t('close')" @click="$emit('clear')">                                         
              {{$t('close')}}
            </button>
          </div>
            
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {formatDate, formatTime} from '../../../shared/typescripts/dates.ts'
export default {
    props: [ 'details', 'locale', 'context', 'booking_details', 'sessions', 'selectedSession', 'admin', 'type', 'time_format_en', 'time_format_fr'],
    data() {
    return {
      dateObject: [],
      days: null,
      }
    },
    methods: {
      privateRoomAvailable() {
        // We either have no accommodations or accommodations of a different type than private room or we have private room and seats are available
        return (!this.booking_details.accommodations || !this.booking_details.accommodations.accommodation_types.includes('private_room')) ||
        (this.booking_details.accommodations &&
        this.booking_details.accommodations.accommodation_types.includes('private_room') && 
        this.details.booth_capacity - this.details.booked_booth > 0)
      },
      seatAvailable() {
        return (this.booking_details.accommodations && 
        this.booking_details.accommodations.accommodation_types.includes('private_room')) || 
        this.details.number_of_seats - this.details.booked_seats > 0
      },
      isAlreadySelected() {
        let index = this.sessions.findIndex(val => val.id === this.details.id)
        return index != -1
      },
      nextStep() {
        this.$emit('nextStep')
      },
      formatDate(dateString) {
        return formatDate(dateString)
      },
      formatTime: function (date) {
        let format = this.locale == 'en' ? this.time_format_en : this.time_format_fr
        return formatTime(date, format)
      },
      formattedAddress(item) {
          return `${item['street_address']}, ${item['city']}, ${item['province']}, ${item['postal_code']}`
      },
      isInPast() {
        let eventStartTime = new Date(this.details.start_time)
        let eventDate = new Date(this.details.date)
        eventDate.setHours(eventStartTime.getHours())
        eventDate.setMinutes(eventStartTime.getMinutes())
        if (eventDate < new Date) {
          return true
        }

      },

      addToCart() {
        let index = this.sessions.findIndex(val => val.id === this.details.id)
        if (index < 0) {
          this.$emit('addToCart')
          this.$emit('clear')
          this.scrollIntoView()
        } 
      },

      scrollIntoView: function() {
        const element = document.getElementsByClassName("selected_session")[0];
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      },

    },
    mounted () {
      this.$i18n.locale = this.locale;
    }
}

</script>
